import React, { Fragment } from 'react';
import {
  Edit,
  Create,
  List,
  DisabledInput,
  EditButton,
  Datagrid,
  SimpleForm,
  TextField,
  NumberInput,
  TextInput,
  CardActions,
  ListButton,
  FunctionField,
  Pagination,
} from 'react-admin';
import BulkDeleteButton from './ui/BulkDeleteButton';

const KeywordWeightTitle = ({ record }) => {
  return <span>Weight for keyword {record ? `"${record.text}"` : ''}</span>;
};

const KeywordWeightEditActions = ({ basePath, data, resource }) => (
  <CardActions>
      <ListButton basePath={basePath} variant="outlined" />
  </CardActions>
);

const KeywordWeightBulkActionButtons = props => (
  <Fragment>
      <BulkDeleteButton {...props} />
  </Fragment>
);

const PostPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />

export const KeywordWeightList = props => (
  <List title="Keywords Weights" {...props} bulkActionButtons={<KeywordWeightBulkActionButtons />} pagination={<PostPagination />} perPage={50}>
    <Datagrid>
      <TextField label="Text" source="text" />
      <TextField label="Weight" source="weight" />
      <FunctionField
        sortable={false}
        source="hours"
        label="Hours"
        render={(record, source) => {
          return (
              record && record['hours'] &&
              <span>{record['hours'].from} - {record['hours'].to}</span>
          );
        }}
      />
      <EditButton />
    </Datagrid>
  </List>
);

export const KeywordWeightEdit = props => (
  <Edit actions={<KeywordWeightEditActions />} title={<KeywordWeightTitle />} {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <TextInput label="Text" source="text" />
      <NumberInput label="Weight (0-1)" source="weight" />
      <NumberInput label="Hour from" source={`hours.from`} step={1} />
      <NumberInput label="Hour to" source={`hours.to`} step={1} />
    </SimpleForm>
  </Edit>
);

export const KeywordWeightCreate = props => (
  <Create title={<KeywordWeightTitle />} {...props}>
    <SimpleForm>
      <TextInput label="Text" source="text" />
      <NumberInput label="Weight (0-1)" source="weight" />
      <NumberInput label="Hour from" source={`hours.from`} step={1} />
      <NumberInput label="Hour to" source={`hours.to`} step={1} />
    </SimpleForm>
  </Create>
);


// WEBPACK FOOTER //
// ./src/resources/keywordweights.js